export Ripple from './Ripple'

export default from './Ripple'



// WEBPACK FOOTER //
// ./src/Ripple/index.js